import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareDashed, Clock, HelpCircle, Copy, Users, TrendingDown } from 'lucide-react';
const problems = [{
  icon: MessageSquareDashed,
  text: 'Te escriben personas que solo preguntan precio y desaparecen.'
}, {
  icon: Clock,
  text: 'Tus vendedores pierden tiempo con consultas que no avanzan.'
}, {
  icon: HelpCircle,
  text: 'No sabés qué modelo conviene publicitar.'
}, {
  icon: Copy,
  text: 'Copiás anuncios de otras tiendas sin saber si funcionan.'
}, {
  icon: Users,
  text: 'Dependés de agencias que no entienden cómo se vende un iPhone.'
}, {
  icon: TrendingDown,
  text: 'Invertís en campañas pero no sabés si realmente generan ventas.'
}];
export function Problem() {
  return <section className="py-20 md:py-32 bg-white" data-id="element-287">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-288">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center mb-16" data-id="element-289">
          <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 tracking-tight mb-6" data-id="element-290">
            Si tus anuncios traen muchos mensajes pero pocas ventas, el problema
            no siempre es Meta Ads.
          </h2>
          <p className="text-lg text-zinc-600 text-balance" data-id="element-291">
            Muchas tiendas de iPhone hacen campañas genéricas, muestran
            cualquier modelo a cualquier persona y terminan pagando mensajes de
            gente que pregunta, compara, desaparece o directamente no tiene
            presupuesto para comprar.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-292">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-zinc-50 border border-zinc-200 rounded-2xl p-6 hover:shadow-md transition-shadow" data-id="element-293">
              <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center mb-4" data-id="element-294">
                <problem.icon className="w-6 h-6 text-red-600" data-id="element-295" />
              </div>
              <p className="text-zinc-800 font-medium leading-snug" data-id="element-296">
                {problem.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}